import * as React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom'

import mixpanel from '@disco/api/mixpanel'

import type { PlaylistId } from 'types/playlist'

import { DropdownMenu, IconButton } from 'components/ds'
import ActionButton from 'components/ui/action-button'
import Icon from 'components/ui/icon'

import PlaylistMenuBody from './playlist-menu-body'
import { usePlaylistSettingsAwait } from './use-playlist-settings-await'

type Props = {
  buttonSize?: 'default' | 'compact'
  playlist:
    | {
        playlist_id: PlaylistId
      }
    | null
    | undefined
  mixpanelContext?: 'Explorer' | 'Playlist pane' | 'Shortlist'
  hideShare?: boolean
  hideShareShortcut?: boolean
}

const PlaylistActions = ({
  buttonSize,
  playlist,
  mixpanelContext,
  hideShare,
  hideShareShortcut,
}: Props): React.ReactNode => {
  const navigate = useNavigate()
  const mobile = useMediaQuery({ maxWidth: 639 })
  const onPlaylistSettingsAwait = usePlaylistSettingsAwait(playlist)

  if (!playlist) return null

  const onShortcutClick = () => {
    mixpanel.sendPureEvent('Click icon', {
      Type: 'Playlist',
      'Playlist ID': playlist.playlist_id,
      Icon: 'Share',
      Context: mixpanelContext,
    })
    navigate(`/explorer/playlists/${playlist.playlist_id}/share`)
  }

  return (
    <>
      {!hideShare && !hideShareShortcut && !mobile && (
        <ActionButton compact icon="share-arrow" onClick={onShortcutClick} />
      )}
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <IconButton
            variant="ghost"
            color="gray"
            size={buttonSize === 'compact' ? '1' : '2'}
            aria-label="More actions"
          >
            <Icon type="ellipsis-vertical" width="20" height="20" />
          </IconButton>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
          <PlaylistMenuBody
            playlist={playlist}
            hideShare={hideShare}
            onPlaylistSettingsAwait={onPlaylistSettingsAwait}
          />
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </>
  )
}

export default PlaylistActions
